const timesheetServiceServiceName = "/Timesheet";

export function timesheetService(http) {
    return {        
        getFinalMonthlyWorkingTime: (data) => {
            return http.get(timesheetServiceServiceName + "/GetFinal", data)
        },
        getSpecificMonthlyWorkingTime: (data) => {
            return http.get(timesheetServiceServiceName + "/GetAllByPersonnelCode", data)
        },
        getMonthlyInOut: (personnelCode, month, year) => {
            var data = {
                params: {
                    personnelCode,
                    month,
                    year
                }
            };
            
            return http.get(timesheetServiceServiceName + "/GetMunthlyCommute", data)
        },
        getHourlyOff: (personnelCode, month, year) => {
            let data = {
                params: {
                    personnelCode,
                    month,
                    year
                }
            };               
            return http.get(timesheetServiceServiceName + "/GetHourlyOff", data)
        },
        getMonthlyMissions: (personnelCode, month, year) => {
            let data = {
                params: {
                    personnelCode,
                    month,
                    year
                }
            };              
            return http.get(timesheetServiceServiceName + "/GetMonthlyMission", data)
        },
        getMonthlyOvertime: (personnelCode, month, year) => {
            let data = {
                params: {
                    personnelCode,
                    month,
                    year
                }
            };              
            return http.get(timesheetServiceServiceName + "/GetMonthlyOvertime", data)
        },
        getHolidayPermissionOvertime: (personnelCode, month, year) => {
            var param = {
                "PersonnelCode": personnelCode,
                "Month": month,
                "Year": year
            }
            return http.post(timesheetServiceServiceName + "/GetHolidayPermissionOvertime", param);
        },
        isSystemProcessing: (personnelCode, yesterday, lastDayOfMonth, year) => {
            let param = {
                "PersonnelCode": personnelCode,
                "Yesterday": yesterday,
                "MonthLastDay": lastDayOfMonth,
                "Year": year
            }
            return http.post(timesheetServiceServiceName + "/IsSystemProcessing", param);
        }

    }
}
